/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-08-16 14:11:09
 * @LastEditors: linxi
 * @LastEditTime: 2021-09-08 10:20:02
 */
import { Button, TableColumnType } from 'antd'
import { getDisposeStatusName } from '../../models/rule'

export const ProcessingDataColumn = (
  onclick: (t: 'look', id: string) => void,
  startIndex: number
): TableColumnType<any>[] => {
  return [
    {
      title: '序号',
      key: 'no',
      width: '4rem',
      align: 'center',
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    // {
    //   title: "预警规则",
    //   dataIndex: "ruleName",
    //   align: "center",
    // },
    // {
    //   title: "执法ID",
    //   dataIndex: "dataCode",
    //   align: "center",
    //   render: (_, r) => <span onClick={copy}>{r.dataCode}</span>,
    // },
    {
      title: '上报卫健委(局)',
      dataIndex: 'osName',
      align: 'left',
    },
    {
      title: '预警机构',
      dataIndex: 'orgName',
      align: 'left',
    },
    {
      title: '预警时间',
      dataIndex: 'cautionTime',
      align: 'center',
    },
    {
      title: '上传时间',
      dataIndex: 'uploadTime',
      align: 'center',
    },
    {
      title: '处置时间',
      dataIndex: 'disposeTime',
      align: 'center',
    },
    {
      title: '处置状态',
      dataIndex: 'statusDesc',
      align: 'center',
      // render: (_, r) => getDisposeStatusName(r.disposeStatus),
    },

    {
      title: '操作',
      align: 'center',
      width: '8rem',
      render: function Element(_, t) {
        return (
          <div>
            <Button
              type='primary'
              ghost
              size='small'
              onClick={() => {
                onclick('look', t.disposeId)
              }}
            >
              查看详情
            </Button>
          </div>
        )
      },
    },
  ]
}
